import { render } from "./alerts-course.vue?vue&type=template&id=57aa1e3e&ts=true"
import script from "./alerts-course.vue?vue&type=script&lang=ts"
export * from "./alerts-course.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__